import { useEffect, useState } from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import MarqueeStrip from "@/components/MarqueeStrip";
import Manifesto from "@/components/Manifesto";
import ProductSpotlight from "@/components/ProductSpotlight";
import Pricing from "@/components/Pricing";
import Testimonials from "@/components/Testimonials";
import Founders from "@/components/Founders";
import Footer from "@/components/Footer";

const Landing = () => {
  const [theme, setTheme] = useState(() => localStorage.getItem("breethe-theme") || "dark");

  useEffect(() => {
    localStorage.setItem("breethe-theme", theme);
  }, [theme]);

  return (
    <div
      className="App bg-[#0A0A0A] text-white font-manrope antialiased overflow-x-clip"
      data-theme={theme}
    >
      <div className="noise-overlay" aria-hidden="true" />
      <Navbar theme={theme} onToggleTheme={() => setTheme((t) => (t === "dark" ? "light" : "dark"))} />
      <main>
        <Hero />
        <MarqueeStrip />
        <Manifesto />
        <ProductSpotlight />
        <Pricing />
        <Testimonials />
        <Founders />
      </main>
      <Footer />
    </div>
  );
};

export default Landing;
